import { Tab, Tabs } from "@heroui/react";
import React from "react";
import UnderlineTabs, { CommonUnderlineTabs } from "./UnderlineTabs";

const CommonTabs = ({
  tab,
  handleTabClick,
  tabs,
  classNames = {},
  variant = "folder",
  selectedKey,
  onSelectionChange,
  ...props
}) => {
  const currentKey = selectedKey !== undefined ? selectedKey : tab;
  const onSelect = onSelectionChange || handleTabClick;

  if (variant === "underlined" || variant === "underline") {
    return (
      <UnderlineTabs
        tabs={tabs}
        selectedKey={currentKey}
        onSelectionChange={onSelect}
        classNames={classNames}
        {...props}
      />
    );
  }

  return (
    <div className="relative z-10 -mb-px">
      <Tabs
        selectedKey={currentKey}
        onSelectionChange={(newKey) => onSelect && onSelect(newKey)}
        classNames={{
          base: "p-0 shadow-none border-none rounded-none text-gray-800 dark:text-gray-100",
          tabList:
            "p-0 border-none shadow-none !border-transparent rounded-b-none text-gray-800 dark:text-gray-100 bg-transparent gap-1 overflow-visible",
          tab: "shadow-none border-none outline-none ring-0 focus:outline-none focus:ring-0 !shadow-none !border-none px-4 py-2 text-gray-800 dark:text-gray-100 rounded-t-xl data-[selected=true]:!bg-white dark:data-[selected=true]:!bg-gray-900",
          cursor:
            "!bg-white dark:!bg-gray-900 shadow-xs border-t border-x border-gray-200 dark:border-gray-800 rounded-t-xl",
          panel: "p-0",
          tabContent:
            "group-data-[selected=true]:font-semibold text-gray-500 dark:text-gray-400 group-data-[selected=true]:text-gray-900 dark:group-data-[selected=true]:text-gray-100 font-semibold text-xs font-sans",
          ...classNames,
        }}
        variant="light"
        aria-label="Tabs"
        {...props}
      >
        {tabs?.map((val) => (
          <Tab
            className="text-gray-800 dark:text-gray-100"
            key={val.key}
            title={
              val.icon ? (
                <div className="flex items-center gap-2">
                  {val.icon}
                  <span>{val.title ?? val.label}</span>
                </div>
              ) : (
                val.title ?? val.label
              )
            }
          />
        ))}
      </Tabs>
    </div>
  );
};

export default CommonTabs;
export { CommonTabs, UnderlineTabs, CommonUnderlineTabs };

